// Routes không hiển thị trên sidebar (detail, create, edit)
// Entry menu "Cấu hình chiết khấu" được thêm vào nhóm Khuyến mãi trong Campaign/router.js
import PackageCreatePage from "./PackageCreate";
import PackageDetailPage from "./PackageDetail";
import PackageEditPage from "./PackageEdit";
import ProgramDetailPage from "./ProgramDetail";

const router = [
  {
    key: "loyalty-package-program-detail",
    path: "/loyalty-package/program/:id",
    component: ProgramDetailPage,
    exact: true,
  },
  {
    key: "loyalty-package-create",
    path: "/loyalty-package/package/create",
    component: PackageCreatePage,
    exact: true,
  },
  {
    key: "loyalty-package-detail",
    path: "/loyalty-package/package/:id",
    component: PackageDetailPage,
    exact: true,
  },
  {
    key: "loyalty-package-edit",
    path: "/loyalty-package/package/edit/:id",
    component: PackageEditPage,
    exact: true,
  },
];

export default router;
